import { createEnum } from "../../utils/utils";

export const LoyaltyLevel = createEnum({
  ADOPTER: "ADOPTER",
  INSIDER: "INSIDER",
  EVANGELIST: "EVANGELIST",
  PARTNER: "PARTNER",
  BELIEVER: "BELIEVER",
});

export const loyaltyColourScheme: Record<
  typeof LoyaltyLevel.T,
  { main: string; secondary: string; text: string }
> = {
  ADOPTER: {
    main: "linear-gradient(159deg, #bcbfc5 0%, #838894 100%);",
    secondary: "#FFFFFF",
    text: "#838894",
  },
  INSIDER: {
    main: "linear-gradient(159deg, #b42b34 0%, #94111a 100%);",
    secondary: "#FFFFFF",
    text: "#94111a",
  },
  EVANGELIST: {
    main: "linear-gradient(159deg, #45879c 0%, #1e4444 100%);",
    secondary: "#FFFFFF",
    text: "#1e4444",
  },
  PARTNER: {
    main: "linear-gradient(159deg, #626365 0%, #232322 100%);",
    secondary: "#FFFFFF",
    text: "#232322",
  },
  BELIEVER: {
    main: "linear-gradient(159deg, #d2d1cf 0%, #b7b6b4 100%);",
    secondary: "#4186ac",
    text: "#b7b6b4",
  },
};
